// Clipboard payload for a directory user, so a Lume account can be linked
// elsewhere without a live directory lookup. Keep the "Lume ID:" line —
// that is the marker.

export type PersonDetailsInput = {
  id: number | string;
  name?: string | null;
  email?: string | null;
};

export function formatPersonDetails(person: PersonDetailsInput): string {
  const name = String(person.name || '').trim();
  const email = String(person.email || '').trim();
  return [`Name: ${name}`, `Email: ${email}`, `Lume ID: ${person.id}`].join('\n');
}

export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      ta.remove();
      return ok;
    } catch {
      return false;
    }
  }
}
